import Modal from "../../layouts/Modal";
import { IPart } from "../../models/Part";

import { TextInput } from "../shared/Inputs/TextInput";
import { useForm } from "react-hook-form";
import usePartMutations from "../../data/usePartMutations";
import { useEffect } from "react";
import { ButtonInput } from "../shared/Inputs/ButtonInput";

interface PartNumberEditProps {
  open: boolean;
  setOpen: any;
  part: IPart | undefined;
}

export default function PartNumberEdit({ open, setOpen, part }: PartNumberEditProps) {
  const { patchPart } = usePartMutations();

  const setPartNumber = (partNumber: string) => {
    patchPart.mutate({ id: part?.id, partNumber: partNumber }, {
      onSuccess: () => {
        setOpen(false);
      }
    })
  };

  const { register, setValue, getValues } = useForm({
    defaultValues: {
      partNumber: part?.partNumber || ""
    }
  });

  useEffect(() => {
    if (open && part) {
      setValue("partNumber", part.partNumber ?? "");
    }
  }, [part, open]);

  return <Modal open={open} setOpen={setOpen} width={"max-w-lg"}>
    <div>
      <h1 className="text-xl font-bold mb-5">Change Part Number</h1>
      <TextInput 
        label="Part Number" 
        register={register} 
        registerName={"partNumber"} 
      />
      <ButtonInput
        classes="mt-5 w-full"
        isSubmit={false}
        onClick={() => setPartNumber(getValues("partNumber"))}
        label="Update Part Number"
      />
    </div>
  </Modal>
}